"use client";

import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Link } from "@/components/common/Link";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import { useState } from "react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileOpen, setMobileOpen] = useState(false);
  if (loading) {
    return <div className="flex gap-1">
        <div className="h-9 w-16 bg-muted/20 animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted/20 animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted/20 animate-pulse rounded-md" />
      </div>;
  }
  return <>
      {}
      <NavigationMenu viewport={false} className="hidden md:flex">
        <NavigationMenuList>
          {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="opacity-0 animate-fade-in-up hover:translate-y-[-2px] transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:underline underline-offset-4 decoration-2 decoration-primary" style={{
              animationDelay: `${i * 100}ms`
            }}>
                  {item.label}
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      {}
      <Button variant="ghost" size="icon" className="md:hidden" onClick={() => setMobileOpen(!mobileOpen)} aria-label="Toggle menu">
        {mobileOpen ? <X /> : <Menu />}
      </Button>

      {}
      {mobileOpen && <div className="absolute top-full left-0 w-full bg-background border-b border-border shadow-medium md:hidden z-50">
          <nav className="flex flex-col p-4 gap-2">
            {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="px-4 py-2 hover:bg-accent hover:text-accent-foreground rounded-md transition-all duration-[var(--duration-fast)]" onClick={() => setMobileOpen(false)}>
                {item.label}
              </Link>)}
          </nav>
        </div>}
    </>;
}
export default function Header() {
  return <header className="sticky top-0 z-40 w-full bg-background/95 backdrop-blur-sm border-b border-border shadow-soft">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        {}
        <Link to="/HomePage" className="flex items-center">
          
        </Link>

        {}
        <MenuProvider menu_id="17" className="flex items-center gap-4">
          <HeaderMenuConsumer />
        </MenuProvider>

        {}
        <Button asChild className="hidden md:inline-flex hover:scale-[1.02] transition-transform duration-[80ms] ease-out">
          <Link to="/ContactPage">Book Now</Link>
        </Button>
      </div>
    </header>;
}